// /* eslint-disable react/jsx-no-useless-fragment */
// /* eslint-disable no-else-return */
// /* eslint-disable no-nested-ternary */
// /* eslint-disable react/react-in-jsx-scope */
// import { RiUser3Line } from 'react-icons/ri';
// import { VscChecklist } from 'react-icons/vsc';
// import { GiDeliveryDrone } from 'react-icons/gi';
// import moment from 'moment';
// import UserInfo from 'components/UserInfo';
// import { Badge, ListInlineItem } from 'reactstrap';
// import DateFormatter from 'components/DateFormatter';
// import { currencyToLocal, NumberWithCommasFormat } from 'utils/constants';

// const currentDateAndTime = moment().format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ');
// const currentDate = moment(currentDateAndTime);
// const previousDateTime = currentDate
//   .subtract(24, 'hours')
//   .format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ');

// const startDateOfYear = moment().startOf('year').format('YYYY-MM-DD');
// const lastDateOfYear = moment().endOf('year').format('YYYY-MM-DD');

// export const startDateOfMonth = moment().startOf('month').format('YYYY-MM-DD');
// export const lastDateOfMonth = moment().endOf('month').format('YYYY-MM-DD');

// const startDateOfWeek = moment().startOf('week').format('YYYY-MM-DD');
// const lastDateOfWeek = moment().endOf('week').format('YYYY-MM-DD');

// export const snapdata = [
//   {
//     title: 'Listing',
//     subData: [
//       { subTitle: 'New Demands', profit: false, count: '23k', total: 240 },
//       { subTitle: 'New Offers', profit: true, count: 246, total: 240 },
//     ],
//     icon: VscChecklist,
//     color: '#F6FBFF',
//   },
//   {
//     title: 'User',
//     subData: [
//       { subTitle: 'KYC Pending', profit: true, count: '23k', total: null },
//       { subTitle: 'New Offers', profit: true, count: 246, total: null },
//     ],
//     icon: RiUser3Line,
//     color: '#F9F7FF',
//   },
//   {
//     title: 'Orders',
//     subData: [
//       { subTitle: 'Delivered', profit: false, count: '23k', total: null },
//       { subTitle: 'Active', profit: true, count: 246, total: null },
//     ],
//     icon: GiDeliveryDrone,
//     color: '#FFF8F2',
//   },
// ];

// export const offerActiveBidColumns = [
//   {
//     accessorKey: 'bidder',
//     header: 'SELLER',
//     cell: ({ row }) => (
//       <UserInfo
//         name={`${row?.original?.bidder?.firstName} ${row?.original?.bidder?.lastName}`}
//         mobileNumber={row?.original?.bidder?.phone}
//       />
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'grade',
//     header: 'GRADE',
//     cell: ({ row }) => <div className="px-0">{row?.original?.grade?.name}</div>,
//     sort: true,
//   },
//   {
//     accessorKey: 'location',
//     header: 'LOCATION',
//     sort: true,
//     cell: ({ row }) => (
//       <>
//         <div className="mb-1">
//           {row?.original?.bidder?.addresses[0]?.city?.cityName}
//         </div>
//         <div className="font-manrope text-active">
//           {row?.original?.bidder?.addresses[0]?.state?.stateName}{' '}
//         </div>
//       </>
//     ),
//   },

//   {
//     accessorKey: 'quantity',
//     header: 'IN STOCK QTY',
//     cell: ({ row }) => (
//       <div className="px-0">
//         {row.original.quantity + row.original.quantityUnit}
//       </div>
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'price',
//     header: 'RATE',
//     cell: ({ row }) => (
//       <div className="px-0">
//         {row?.original?.rateUnit?.currencyName
//           ? row?.original?.rateUnit?.currencyName
//           : row?.original?.price
//             ? row?.original?.price
//             : ''}
//       </div>
//     ),
//     sort: true,
//   },
//   { accessorKey: 'offer.offerType', header: 'TYPE', sort: true },
//   {
//     accessorKey: '',
//     header: 'INACTIVE BID',
//     cell: ({ row }) => (
//       <div className="px-0">{row.original?.offer?.inactiveBids}</div>
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: '',
//     header: 'ACTIVE BID',
//     cell: ({ row }) => (
//       <div className="px-0">{row.original?.offer?.activeBids}</div>
//     ),
//     sort: true,
//   },

//   // { accessorKey: 'total', header: 'BID', sort: true },
//   // {
//   //   accessorKey: 'roles',
//   //   header: 'Role',
//   //   Cell: rolesCellValue,
//   //   disableSortBy: true,
//   // },
//   // {
//   //   accessorKey: 'organizations',
//   //   header: 'Organizations',
//   //   Cell: orgCellValue,
//   //   disableSortBy: true,
//   // },
// ];

// export const demandActiveBidColumns = [
//   {
//     accessorKey: 'bidder',
//     header: 'BUYER',
//     cell: ({ row }) => (
//       <UserInfo
//         name={`${row?.original?.bidder?.firstName} ${row?.original?.bidder?.lastName}`}
//         mobileNumber={row?.original?.bidder?.phone}
//       />
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'grade',
//     header: 'GRADE',
//     cell: ({ row }) => <div className="px-0">{row?.original?.grade?.name}</div>,
//     sort: true,
//   },
//   {
//     accessorKey: '',
//     header: 'LOCATION',
//     cell: ({ row }) => (
//       <>
//         <div className="mb-0">
//           {row?.original?.bidder?.addresses[0]?.city?.cityName}
//         </div>
//         <div className="font-manrope text-active">
//           {row?.original?.bidder?.addresses[0]?.state?.stateName}{' '}
//         </div>
//       </>
//     ),
//     sort: true,
//   },

//   {
//     accessorKey: 'quantity',
//     header: 'IN STOCK QTY',
//     cell: ({ row }) => (
//       <div className="px-0">
//         {row.original.quantity + row.original.quantityUnit}
//       </div>
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'price',
//     header: 'RATE',
//     cell: ({ row }) => (
//       <div className="px-0">
//         {row?.original?.rateUnit?.currencyName
//           ? row?.original?.rateUnit?.currencyName
//           : row?.original?.price
//             ? row?.original?.price
//             : ''}
//         /kg
//       </div>
//     ),
//     sort: true,
//   },
//   { accessorKey: 'demand.demandType', header: 'TYPE', sort: true },
//   {
//     accessorKey: '',
//     header: 'INACTIVE BID',
//     cell: ({ row }) => (
//       <div className="px-0">{row.original?.demand?.inactiveBids}</div>
//     ),
//     sort: true,
//   },

//   {
//     accessorKey: '',
//     header: 'ACTIVE BID',
//     cell: ({ row }) => (
//       <div className="px-0">{row.original?.demand?.activeBids}</div>
//     ),
//     sort: true,
//   },
// ];

// export const options = {
//   showTotal: true,
// };

// export const currentYearDefaultFilter = (groupOn) => {
//   return { fromDate: startDateOfYear, toDate: lastDateOfYear, groupOn };
// };

// export const currentMonthDefaultFilter = (groupOn) => {
//   return { fromDate: startDateOfMonth, toDate: lastDateOfMonth, groupOn };
// };

// export const currentWeekDefaultFilter = (groupOn) => {
//   return { fromDate: startDateOfWeek, toDate: lastDateOfWeek, groupOn };
// };
// export const currentDateDefaultFilter = (groupOn) => {
//   // const fromDate = moment(todayDate).subtract(24, 'hours').valueOf();

//   // console.log('fromDate ', currentDateAndTime, previousDateTime);
//   // return { fromDate, toDate: moment().valueOf(), groupOn };
//   return { fromDate: previousDateTime, toDate: currentDateAndTime, groupOn };
// };

// export const defaultFiltersForDates = (groupOn) => {
//   if (groupOn === 'this_year') {
//     return currentYearDefaultFilter('month');
//   } else if (groupOn === 'this_month') {
//     return currentMonthDefaultFilter('day');
//   } else if (groupOn === 'this_week') {
//     return currentWeekDefaultFilter('day');
//   } else {
//     return currentDateDefaultFilter('day');
//   }
// };

// export const showDates = (dateString) => {
//   const dateObject = moment(dateString, 'YYYY-MM-DD');
//   return dateObject.format('D MMM');
// };

// export const CHART_BOTTOM_HEADING = [
//   {
//     id: 1,
//     // title: 'New Listing',
//     subTitle: [{ label: 'New Demands ' }, { label: 'New Offers' }],
//   },
//   {
//     id: 2,
//     title: 'Active Bids',
//     subTitle: [{ label: 'New Demands ' }, { label: 'New Offers' }],
//   },
//   {
//     id: 3,
//     title: 'Vendors',
//     subTitle: [{ label: 'New Vendors' }, { label: 'Total Vendors' }],
//   },
//   {
//     id: 4,
//     title: 'Orders',
//     subTitle: [{ label: 'Pending Orders' }, { label: 'Paid Orders' }],
//   },
//   {
//     id: 5,
//     title: 'Transportation',
//     subTitle: [{ label: 'Loading' }, { label: 'Delivered' }],
//   },
// ];

// export const getChartBottomHeading = (id) => {
//   const title = CHART_BOTTOM_HEADING.find((val) => {
//     if (val.id === id) return val;
//   });
//   return (
//     <>
//       <ListInlineItem>
//         <span />
//         {title?.subTitle[0]?.label}
//       </ListInlineItem>
//       <ListInlineItem>
//         <span />
//         {title?.subTitle[1]?.label}
//       </ListInlineItem>
//     </>
//   );
// };

// export const COUNT_DATA = [
//   {
//     id: 1,
//     title: 'Active Listing',
//     subTitle: [
//       { label: 'Offers', value: 23 },
//       { label: 'Demands', value: 65 },
//     ],
//   },
//   {
//     id: 2,
//     title: 'Active Bids',
//     subTitle: [
//       { label: 'Offers', value: 2386 },
//       { label: 'Demands', value: 246 },
//     ],
//   },
//   {
//     id: 3,
//     title: 'Vendors',
//     subTitle: [
//       { label: 'New', value: 2386 },
//       { label: 'Total', value: 246 },
//     ],
//   },
//   {
//     id: 4,
//     title: 'Orders',
//     subTitle: [
//       { label: 'Pending', value: 2386 },
//       { label: 'Paid', value: 246 },
//     ],
//   },
//   {
//     id: 5,
//     title: 'Invoices',
//     subTitle: [
//       { label: 'Fully Paid', value: 23 },
//       { label: 'Unpaid', value: 246 },
//     ],
//   },
// ];
// export const DASHBOARD_TABS = {
//   LISTINGS: 'Listings',
//   BIDS: 'Bids',
//   VENDORS: 'Vendors',
//   INVOICES: 'Invoices',
// };

// export const LISTING_TABS = {
//   NEW_OFFERS: 'New Offers',
//   NEW_DEMANDS: 'New Demands',
// };

// export const setChartValue = (val1, val2) => {
//   const combinedKeysSet = new Set();
//   let firstLineData = [];
//   let secondLineData = [];
//   if (val1) {
//     firstLineData = Object.entries(val1).map(([key, value]) => {
//       combinedKeysSet.add(key);
//       return value;
//     });
//   }
//   if (val2) {
//     secondLineData = Object.entries(val2).map(([key, value]) => {
//       combinedKeysSet.add(key);
//       return value;
//     });
//   }
//   const combinedKeys = Array.from(combinedKeysSet);
//   return {
//     firstLineData,
//     secondLineData,
//     combinedKeys,
//   };
// };

// export const dashboardOffersColumns = [
//   // {
//   //   accessorKey: 'trader',
//   //   header: 'SELLER',
//   //   enableColumnFilter: true,
//   //   enableSorting: true,
//   //   cell: ({ row }) => {
//   //     const firstName = row?.original?.trader?.firstName
//   //       ? row?.original?.trader?.firstName
//   //       : '';
//   //     const lastName = row?.original?.trader?.lastName
//   //       ? row?.original?.trader?.lastName
//   //       : '';
//   //     const phone = row?.original?.trader.phone || 'N/A';
//   //     return (
//   //       <UserInfo name={`${firstName} ${lastName}`} mobileNumber={phone} />
//   //     );
//   //   },
//   // },
//   { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
//   {
//     accessorKey: 'trader',
//     header: 'Seller',
//     // enableColumnFilter: true,
//     enableSorting: true,
//     accessorFn: (row) => {
//       return (
//         <UserInfo
//           name={row?.trader?.entityName}
//           mobileNumber={`${row?.trader?.callingCode?.callingCode}-${row?.trader?.phone}`}
//         />
//       );
//     },
//     cell: (info) => info.getValue(),
//   },
//   { accessorKey: 'id', header: 'OFFER ID', enableSorting: true },
//   {
//     accessorKey: 'grades',
//     header: 'GRADE',
//     accessorFn: (row) => {
//       return row?.grades?.map((grade) => {
//         return (
//           <Badge key={grade?.id} color="primary" className="me-1">
//             {grade?.name}
//           </Badge>
//         );
//       });
//     },
//     cell: (info) => info.getValue(),
//     enableSorting: false,
//   },
//   // {
//   //   accessorFn: (row) => {
//   //     return (
//   //       <>
//   //         <div className="mb-1">{row.city?.cityName}</div>
//   //         <div className="font-manrope text-active">{row.state?.stateName}</div>
//   //       </>
//   //     );
//   //   },
//   //   header: 'LOCATION',
//   //   id: 'city.cityName',
//   //   enableSorting: true,
//   //   cell: (info) => info.getValue(),
//   // },
//   {
//     accessorFn: (row) => {
//       return (
//         <>
//           {row?.offerType === 'FOREIGN' ? (
//             <div className="mb-1">
//               {row?.portsOfDischarge?.map((portOfDischarge) => {
//                 return (
//                   <div key={portOfDischarge?.id} className="me-1">
//                     {`${portOfDischarge?.name},` || 'Not Available'}
//                   </div>
//                 );
//               })}
//             </div>
//           ) : (
//             <>
//               <div className="mb-1">
//                 {row.city?.cityName || 'Not Available'}
//               </div>
//               <div className="font-manrope text-active">
//                 {row.state?.stateName || 'Not Available'}
//               </div>
//             </>
//           )}
//         </>
//       );
//     },
//     header: 'LOCATION',
//     id: 'city.cityName',
//     enableSorting: true,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: 'totalQty',
//     header: 'Total Quantity',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.totalQty)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     // cell: ({ getValue }) => {
//     //   return <div>{getValue()}kg</div>;
//     // },
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'minimumQty',
//     header: 'min. QTY',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.minimumQty)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     // cell: ({ getValue }) => {
//     //   // const { minimumQty } = getValue();
//     //   return (
//     //     <div>{getValue()}</div>
//     //     // <UserInfo name={`${firstName} ${lastName}`} mobileNumber={phone} />
//     //   );
//     // },
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'rate',
//     header: 'RATE',
//     cell: ({ row }) => (
//       <div>
//         {currencyToLocal(
//           row?.original?.rate,
//           row?.original?.rateUnit?.isoCurrencyCode,
//         )}
//         /{row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   // {
//   //   header: 'RATE',
//   //   accessorFn: (row) => {
//   //     // const isoCurrencyCode = row?.rateUnit?.isoCurrencyCode;
//   //     const price = row?.rate;
//   //     return <div className="px-1">{`${price}/kg`}</div>;
//   //   },
//   //   cell: (info) => info.getValue(),
//   //   id: 'rate',
//   //   enableSorting: true,
//   // },
//   { accessorKey: 'offerType', header: 'TYPE', enableSorting: true },
//   { accessorKey: 'activeBids', header: 'active bids', enableSorting: false },
//   // {
//   //   accessorKey: 'inactiveBids',
//   //   header: 'inactive bids',
//   //   enableSorting: false,
//   // },
//   {
//     accessorKey: 'createdAt',
//     header: 'Created At',
//     cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     enableSorting: true,
//   },
// ];

// export const dashboardDemandsColumns = [
//   { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },

//   {
//     accessorKey: 'trader',
//     header: 'buyer',
//     // enableColumnFilter: true,
//     enableSorting: true,
//     accessorFn: (row) => {
//       return (
//         <UserInfo
//           name={row?.trader?.entityName}
//           mobileNumber={`${row?.trader?.callingCode?.callingCode}-${row?.trader?.phone}`}
//         />
//       );
//     },
//     cell: (info) => info.getValue(),
//   },
//   { accessorKey: 'id', header: 'DEMAND ID', enableSorting: true },
//   {
//     accessorKey: 'grades',
//     header: 'GRADE',
//     accessorFn: (row) => {
//       return row?.grades?.map((grade) => {
//         return (
//           <Badge key={grade?.id} color="primary" className="me-1">
//             {grade?.name}
//           </Badge>
//         );
//       });
//     },
//     cell: (info) => info.getValue(),
//     enableSorting: false,
//   },
//   // {
//   //   accessorFn: (row) => {
//   //     return (
//   //       <>
//   //         <div className="mb-1">{row.city?.cityName}</div>
//   //         <div className="font-manrope text-nowrap text-active">
//   //           {row.state?.stateName}
//   //         </div>
//   //       </>
//   //     );
//   //   },
//   //   header: 'LOCATION',
//   //   id: 'city.cityName',
//   //   enableSorting: true,
//   //   cell: (info) => info.getValue(),
//   // },
//   {
//     accessorFn: (row) => {
//       return (
//         <>
//           {row?.demandType === 'FOREIGN' ? (
//             <div className="mb-1">
//               {row?.portsOfDischarge?.map((portOfDischarge) => {
//                 return (
//                   <div key={portOfDischarge?.id} className="me-1">
//                     {`${portOfDischarge?.name},` || 'Not Available'}
//                   </div>
//                 );
//               })}
//             </div>
//           ) : (
//             <>
//               <div className="mb-1">
//                 {row.city?.cityName || 'Not Available'}
//               </div>
//               <div className="font-manrope text-active">
//                 {row.state?.stateName || 'Not Available'}
//               </div>
//             </>
//           )}
//           {/* <div className="mb-1">{row.city?.cityName}</div>
//           <div className="font-manrope text-active">{row.state?.stateName}</div> */}
//         </>
//       );
//     },
//     header: 'LOCATION',
//     id: 'city.cityName',
//     enableSorting: true,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: 'totalQty',
//     header: 'Total Quantity',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.totalQty)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'minimumQty',
//     header: 'min. QTY',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.minimumQty)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'rate',
//     header: 'RATE',
//     cell: ({ row }) => (
//       <div>
//         {currencyToLocal(
//           row?.original?.rate,
//           row?.original?.rateUnit?.isoCurrencyCode,
//         )}
//         /{row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   { accessorKey: 'demandType', header: 'TYPE', enableSorting: true },
//   { accessorKey: 'activeBids', header: 'active bids', enableSorting: false },
//   // {
//   //   accessorKey: 'inactiveBids',
//   //   header: 'inactive bids',
//   //   enableSorting: false,
//   // },
//   {
//     accessorKey: 'createdAt',
//     header: 'Created At',
//     cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     enableSorting: true,
//   },
// ];

// /* eslint-disable react/jsx-no-useless-fragment */
// /* eslint-disable no-else-return */
// /* eslint-disable no-nested-ternary */
// /* eslint-disable react/react-in-jsx-scope */
// import { RiUser3Line } from 'react-icons/ri';
// import { VscChecklist } from 'react-icons/vsc';
// import { GiDeliveryDrone } from 'react-icons/gi';
// import moment from 'moment';
// import UserInfo from 'components/UserInfo';
// import { Badge, ListInlineItem } from 'reactstrap';
// import DateFormatter from 'components/DateFormatter';
// import { currencyToLocal, NumberWithCommasFormat } from 'utils/constants';

// const currentDateAndTime = moment().format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ');
// const currentDate = moment(currentDateAndTime);
// const previousDateTime = currentDate
//   .subtract(24, 'hours')
//   .format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ');

// const startDateOfYear = moment().startOf('year').format('YYYY-MM-DD');
// const lastDateOfYear = moment().endOf('year').format('YYYY-MM-DD');

// export const startDateOfMonth = moment().startOf('month').format('YYYY-MM-DD');
// export const lastDateOfMonth = moment().endOf('month').format('YYYY-MM-DD');

// const startDateOfWeek = moment().startOf('week').format('YYYY-MM-DD');
// const lastDateOfWeek = moment().endOf('week').format('YYYY-MM-DD');

// export const snapdata = [
//   {
//     title: 'Listing',
//     subData: [
//       { subTitle: 'New Demands', profit: false, count: '23k', total: 240 },
//       { subTitle: 'New Offers', profit: true, count: 246, total: 240 },
//     ],
//     icon: VscChecklist,
//     color: '#F6FBFF',
//   },
//   {
//     title: 'User',
//     subData: [
//       { subTitle: 'KYC Pending', profit: true, count: '23k', total: null },
//       { subTitle: 'New Offers', profit: true, count: 246, total: null },
//     ],
//     icon: RiUser3Line,
//     color: '#F9F7FF',
//   },
//   {
//     title: 'Orders',
//     subData: [
//       { subTitle: 'Delivered', profit: false, count: '23k', total: null },
//       { subTitle: 'Active', profit: true, count: 246, total: null },
//     ],
//     icon: GiDeliveryDrone,
//     color: '#FFF8F2',
//   },
// ];

// export const offerActiveBidColumns = [
//   {
//     accessorKey: 'bidder',
//     header: 'SELLER',
//     cell: ({ row }) => (
//       <UserInfo
//         name={`${row?.original?.bidder?.firstName} ${row?.original?.bidder?.lastName}`}
//         mobileNumber={row?.original?.bidder?.phone}
//       />
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'grade',
//     header: 'GRADE',
//     cell: ({ row }) => <div className="px-0">{row?.original?.grade?.name}</div>,
//     sort: true,
//   },
//   {
//     accessorKey: 'location',
//     header: 'LOCATION',
//     sort: true,
//     cell: ({ row }) => (
//       <>
//         <div className="mb-1">
//           {row?.original?.bidder?.addresses[0]?.city?.cityName}
//         </div>
//         <div className="font-manrope text-active">
//           {row?.original?.bidder?.addresses[0]?.state?.stateName}{' '}
//         </div>
//       </>
//     ),
//   },

//   {
//     accessorKey: 'quantity',
//     header: 'IN STOCK QTY',
//     cell: ({ row }) => (
//       <div className="px-0">
//         {row.original.quantity + row.original.quantityUnit}
//       </div>
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'price',
//     header: 'RATE',
//     cell: ({ row }) => (
//       <div className="px-0">
//         {row?.original?.rateUnit?.currencyName
//           ? row?.original?.rateUnit?.currencyName
//           : row?.original?.price
//             ? row?.original?.price
//             : ''}
//       </div>
//     ),
//     sort: true,
//   },
//   { accessorKey: 'offer.offerType', header: 'TYPE', sort: true },
//   {
//     accessorKey: '',
//     header: 'INACTIVE BID',
//     cell: ({ row }) => (
//       <div className="px-0">{row.original?.offer?.inactiveBids}</div>
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: '',
//     header: 'ACTIVE BID',
//     cell: ({ row }) => (
//       <div className="px-0">{row.original?.offer?.activeBids}</div>
//     ),
//     sort: true,
//   },

//   // { accessorKey: 'total', header: 'BID', sort: true },
//   // {
//   //   accessorKey: 'roles',
//   //   header: 'Role',
//   //   Cell: rolesCellValue,
//   //   disableSortBy: true,
//   // },
//   // {
//   //   accessorKey: 'organizations',
//   //   header: 'Organizations',
//   //   Cell: orgCellValue,
//   //   disableSortBy: true,
//   // },
// ];

// export const demandActiveBidColumns = [
//   {
//     accessorKey: 'bidder',
//     header: 'BUYER',
//     cell: ({ row }) => (
//       <UserInfo
//         name={`${row?.original?.bidder?.firstName} ${row?.original?.bidder?.lastName}`}
//         mobileNumber={row?.original?.bidder?.phone}
//       />
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'grade',
//     header: 'GRADE',
//     cell: ({ row }) => <div className="px-0">{row?.original?.grade?.name}</div>,
//     sort: true,
//   },
//   {
//     accessorKey: '',
//     header: 'LOCATION',
//     cell: ({ row }) => (
//       <>
//         <div className="mb-0">
//           {row?.original?.bidder?.addresses[0]?.city?.cityName}
//         </div>
//         <div className="font-manrope text-active">
//           {row?.original?.bidder?.addresses[0]?.state?.stateName}{' '}
//         </div>
//       </>
//     ),
//     sort: true,
//   },

//   {
//     accessorKey: 'quantity',
//     header: 'IN STOCK QTY',
//     cell: ({ row }) => (
//       <div className="px-0">
//         {row.original.quantity + row.original.quantityUnit}
//       </div>
//     ),
//     sort: true,
//   },
//   {
//     accessorKey: 'price',
//     header: 'RATE',
//     cell: ({ row }) => (
//       <div className="px-0">
//         {row?.original?.rateUnit?.currencyName
//           ? row?.original?.rateUnit?.currencyName
//           : row?.original?.price
//             ? row?.original?.price
//             : ''}
//         /kg
//       </div>
//     ),
//     sort: true,
//   },
//   { accessorKey: 'demand.demandType', header: 'TYPE', sort: true },
//   {
//     accessorKey: '',
//     header: 'INACTIVE BID',
//     cell: ({ row }) => (
//       <div className="px-0">{row.original?.demand?.inactiveBids}</div>
//     ),
//     sort: true,
//   },

//   {
//     accessorKey: '',
//     header: 'ACTIVE BID',
//     cell: ({ row }) => (
//       <div className="px-0">{row.original?.demand?.activeBids}</div>
//     ),
//     sort: true,
//   },
// ];

// export const options = {
//   showTotal: true,
// };

// export const currentYearDefaultFilter = (groupOn) => {
//   return { fromDate: startDateOfYear, toDate: lastDateOfYear, groupOn };
// };

// export const currentMonthDefaultFilter = (groupOn) => {
//   return { fromDate: startDateOfMonth, toDate: lastDateOfMonth, groupOn };
// };

// export const currentWeekDefaultFilter = (groupOn) => {
//   return { fromDate: startDateOfWeek, toDate: lastDateOfWeek, groupOn };
// };
// export const currentDateDefaultFilter = (groupOn) => {
//   // const fromDate = moment(todayDate).subtract(24, 'hours').valueOf();

//   // console.log('fromDate ', currentDateAndTime, previousDateTime);
//   // return { fromDate, toDate: moment().valueOf(), groupOn };
//   return { fromDate: previousDateTime, toDate: currentDateAndTime, groupOn };
// };

// // Add this helper function to format X-axis labels
// export const formatXAxisLabels = (selectedOption) => {
//   if (selectedOption === 'this_year') {
//     // Return months 1-12
//     return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   } else if (selectedOption === 'this_month') {
//     // Return days with interval (3, 6, 9, 12, 15, 18, 21, 24, 27, 30)
//     const days = [];
//     const daysInMonth = moment().daysInMonth();
//     for (let i = 3; i <= daysInMonth; i += 3) {
//       days.push(i.toString());
//     }
//     return days;
//   } else if (selectedOption === 'this_week') {
//     // Return 1-7 for week days
//     return ['1', '2', '3', '4', '5', '6', '7'];
//   } else {
//     // Return time intervals for today (6am, 9am, 12pm, 3pm, 6pm, 9pm, 12am, 3am)
//     return ['6am', '9am', '12pm', '3pm', '6pm', '9pm', '12am', '3am'];
//   }
// };

// // Update this function to return proper date ranges
// export const defaultFiltersForDates = (groupOn) => {
//   if (groupOn === 'this_year') {
//     return {
//       fromDate: startDateOfYear,
//       toDate: lastDateOfYear,
//       groupOn: 'month'
//     };
//   } else if (groupOn === 'this_month') {
//     return {
//       fromDate: startDateOfMonth,
//       toDate: lastDateOfMonth,
//       groupOn: 'day'
//     };
//   } else if (groupOn === 'this_week') {
//     return {
//       fromDate: startDateOfWeek,
//       toDate: lastDateOfWeek,
//       groupOn: 'day'
//     };
//   } else {
//     return {
//       fromDate: previousDateTime,
//       toDate: currentDateAndTime,
//       groupOn: 'hour'
//     };
//   }
// };

// export const showDates = (dateString) => {
//   const dateObject = moment(dateString, 'YYYY-MM-DD');
//   return dateObject.format('D MMM');
// };

// export const CHART_BOTTOM_HEADING = [
//   {
//     id: 1,
//     // title: 'New Listing',
//     subTitle: [{ label: 'New Demands ' }, { label: 'New Offers' }],
//   },
//   {
//     id: 2,
//     title: 'Active Bids',
//     subTitle: [{ label: 'New Demands ' }, { label: 'New Offers' }],
//   },
//   {
//     id: 3,
//     title: 'Vendors',
//     subTitle: [{ label: 'New Vendors' }, { label: 'Total Vendors' }],
//   },
//   {
//     id: 4,
//     title: 'Orders',
//     subTitle: [{ label: 'Pending Orders' }, { label: 'Paid Orders' }],
//   },
//   // {
//   //   id: 5,
//   //   title: 'Transportation',
//   //   subTitle: [{ label: 'Loading' }, { label: 'Delivered' }],
//   // },
// ];

// export const getChartBottomHeading = (id) => {
//   const title = CHART_BOTTOM_HEADING.find((val) => {
//     if (val.id === id) return val;
//   });
//   return (
//     <>
//       <ListInlineItem>
//         <span />
//         {title?.subTitle[0]?.label}
//       </ListInlineItem>
//       <ListInlineItem>
//         <span />
//         {title?.subTitle[1]?.label}
//       </ListInlineItem>
//     </>
//   );
// };

// export const COUNT_DATA = [
//   {
//     id: 1,
//     title: 'Active Listing',
//     subTitle: [
//       { label: 'Offers', value: 23 },
//       { label: 'Demands', value: 65 },
//     ],
//   },
//   {
//     id: 2,
//     title: 'Active Bids',
//     subTitle: [
//       { label: 'Offers', value: 2386 },
//       { label: 'Demands', value: 246 },
//     ],
//   },
//   {
//     id: 3,
//     title: 'Vendors',
//     subTitle: [
//       { label: 'New', value: 2386 },
//       { label: 'Total', value: 246 },
//     ],
//   },
//   {
//     id: 4,
//     title: 'Orders',
//     subTitle: [
//       { label: 'Pending', value: 2386 },
//       { label: 'Paid', value: 246 },
//     ],
//   },
//   // {
//   //   id: 5,
//   //   title: 'Invoices',
//   //   subTitle: [
//   //     { label: 'Fully Paid', value: 23 },
//   //     { label: 'Unpaid', value: 246 },
//   //   ],
//   // },
// ];
// export const DASHBOARD_TABS = {
//   LISTINGS: 'Listings',
//   BIDS: 'Bids',
//   VENDORS: 'Vendors',
//   // INVOICES: 'Invoices',
// };

// export const LISTING_TABS = {
//   NEW_OFFERS: 'New Offers',
//   NEW_DEMANDS: 'New Demands',
// };

// export const setChartValue = (val1, val2) => {
//   const combinedKeysSet = new Set();
//   let firstLineData = [];
//   let secondLineData = [];
//   if (val1) {
//     firstLineData = Object.entries(val1).map(([key, value]) => {
//       combinedKeysSet.add(key);
//       return value;
//     });
//   }
//   if (val2) {
//     secondLineData = Object.entries(val2).map(([key, value]) => {
//       combinedKeysSet.add(key);
//       return value;
//     });
//   }
//   const combinedKeys = Array.from(combinedKeysSet);
//   return {
//     firstLineData,
//     secondLineData,
//     combinedKeys,
//   };
// };

// export const dashboardOffersColumns = [
//   // {
//   //   accessorKey: 'trader',
//   //   header: 'SELLER',
//   //   enableColumnFilter: true,
//   //   enableSorting: true,
//   //   cell: ({ row }) => {
//   //     const firstName = row?.original?.trader?.firstName
//   //       ? row?.original?.trader?.firstName
//   //       : '';
//   //     const lastName = row?.original?.trader?.lastName
//   //       ? row?.original?.trader?.lastName
//   //       : '';
//   //     const phone = row?.original?.trader.phone || 'N/A';
//   //     return (
//   //       <UserInfo name={`${firstName} ${lastName}`} mobileNumber={phone} />
//   //     );
//   //   },
//   // },
//   { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
//   {
//     accessorKey: 'trader',
//     header: 'Seller',
//     // enableColumnFilter: true,
//     enableSorting: true,
//     accessorFn: (row) => {
//       return (
//         <UserInfo
//           name={row?.trader?.entityName}
//           mobileNumber={`${row?.trader?.callingCode?.callingCode}-${row?.trader?.phone}`}
//         />
//       );
//     },
//     cell: (info) => info.getValue(),
//   },
//   { accessorKey: 'id', header: 'OFFER ID', enableSorting: true },
//   {
//     accessorKey: 'grades',
//     header: 'GRADE',
//     accessorFn: (row) => {
//       return row?.grades?.map((grade) => {
//         return (
//           <Badge key={grade?.id} color="primary" className="me-1">
//             {grade?.name}
//           </Badge>
//         );
//       });
//     },
//     cell: (info) => info.getValue(),
//     enableSorting: false,
//   },
//   // {
//   //   accessorFn: (row) => {
//   //     return (
//   //       <>
//   //         <div className="mb-1">{row.city?.cityName}</div>
//   //         <div className="font-manrope text-active">{row.state?.stateName}</div>
//   //       </>
//   //     );
//   //   },
//   //   header: 'LOCATION',
//   //   id: 'city.cityName',
//   //   enableSorting: true,
//   //   cell: (info) => info.getValue(),
//   // },
//   {
//     accessorFn: (row) => {
//       return (
//         <>
//           {row?.offerType === 'FOREIGN' ? (
//             <div className="mb-1">
//               {row?.portsOfDischarge?.map((portOfDischarge) => {
//                 return (
//                   <div key={portOfDischarge?.id} className="me-1">
//                     {`${portOfDischarge?.name},` || 'Not Available'}
//                   </div>
//                 );
//               })}
//             </div>
//           ) : (
//             <>
//               <div className="mb-1">
//                 {row.city?.cityName || 'Not Available'}
//               </div>
//               <div className="font-manrope text-active">
//                 {row.state?.stateName || 'Not Available'}
//               </div>
//             </>
//           )}
//         </>
//       );
//     },
//     header: 'LOCATION',
//     id: 'city.cityName',
//     enableSorting: true,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: 'totalQty',
//     header: 'Total Quantity',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.totalQty)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     // cell: ({ getValue }) => {
//     //   return <div>{getValue()}kg</div>;
//     // },
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'minimumQty',
//     header: 'min. QTY',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.minimumQty)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     // cell: ({ getValue }) => {
//     //   // const { minimumQty } = getValue();
//     //   return (
//     //     <div>{getValue()}</div>
//     //     // <UserInfo name={`${firstName} ${lastName}`} mobileNumber={phone} />
//     //   );
//     // },
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'rate',
//     header: 'RATE',
//     cell: ({ row }) => (
//       <div>
//         {currencyToLocal(
//           row?.original?.rate,
//           row?.original?.rateUnit?.isoCurrencyCode,
//         )}
//         /{row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   // {
//   //   header: 'RATE',
//   //   accessorFn: (row) => {
//   //     // const isoCurrencyCode = row?.rateUnit?.isoCurrencyCode;
//   //     const price = row?.rate;
//   //     return <div className="px-1">{`${price}/kg`}</div>;
//   //   },
//   //   cell: (info) => info.getValue(),
//   //   id: 'rate',
//   //   enableSorting: true,
//   // },
//   { accessorKey: 'offerType', header: 'TYPE', enableSorting: true },
//   { accessorKey: 'activeBids', header: 'active bids', enableSorting: false },
//   // {
//   //   accessorKey: 'inactiveBids',
//   //   header: 'inactive bids',
//   //   enableSorting: false,
//   // },
//   {
//     accessorKey: 'createdAt',
//     header: 'Created At',
//     cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     enableSorting: true,
//   },
// ];

// export const dashboardDemandsColumns = [
//   { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },

//   {
//     accessorKey: 'trader',
//     header: 'buyer',
//     // enableColumnFilter: true,
//     enableSorting: true,
//     accessorFn: (row) => {
//       return (
//         <UserInfo
//           name={row?.trader?.entityName}
//           mobileNumber={`${row?.trader?.callingCode?.callingCode}-${row?.trader?.phone}`}
//         />
//       );
//     },
//     cell: (info) => info.getValue(),
//   },
//   { accessorKey: 'id', header: 'DEMAND ID', enableSorting: true },
//   {
//     accessorKey: 'grades',
//     header: 'GRADE',
//     accessorFn: (row) => {
//       return row?.grades?.map((grade) => {
//         return (
//           <Badge key={grade?.id} color="primary" className="me-1">
//             {grade?.name}
//           </Badge>
//         );
//       });
//     },
//     cell: (info) => info.getValue(),
//     enableSorting: false,
//   },
//   // {
//   //   accessorFn: (row) => {
//   //     return (
//   //       <>
//   //         <div className="mb-1">{row.city?.cityName}</div>
//   //         <div className="font-manrope text-nowrap text-active">
//   //           {row.state?.stateName}
//   //         </div>
//   //       </>
//   //     );
//   //   },
//   //   header: 'LOCATION',
//   //   id: 'city.cityName',
//   //   enableSorting: true,
//   //   cell: (info) => info.getValue(),
//   // },
//   {
//     accessorFn: (row) => {
//       return (
//         <>
//           {row?.demandType === 'FOREIGN' ? (
//             <div className="mb-1">
//               {row?.portsOfDischarge?.map((portOfDischarge) => {
//                 return (
//                   <div key={portOfDischarge?.id} className="me-1">
//                     {`${portOfDischarge?.name},` || 'Not Available'}
//                   </div>
//                 );
//               })}
//             </div>
//           ) : (
//             <>
//               <div className="mb-1">
//                 {row.city?.cityName || 'Not Available'}
//               </div>
//               <div className="font-manrope text-active">
//                 {row.state?.stateName || 'Not Available'}
//               </div>
//             </>
//           )}
//           {/* <div className="mb-1">{row.city?.cityName}</div>
//           <div className="font-manrope text-active">{row.state?.stateName}</div> */}
//         </>
//       );
//     },
//     header: 'LOCATION',
//     id: 'city.cityName',
//     enableSorting: true,
//     cell: (info) => info.getValue(),
//   },
//   {
//     accessorKey: 'totalQty',
//     header: 'Total Quantity',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.totalQty)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'minimumQty',
//     header: 'min. QTY',
//     cell: ({ row }) => (
//       <div>
//         {NumberWithCommasFormat(row?.original?.minimumQty)}
//         {row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   {
//     accessorKey: 'rate',
//     header: 'RATE',
//     cell: ({ row }) => (
//       <div>
//         {currencyToLocal(
//           row?.original?.rate,
//           row?.original?.rateUnit?.isoCurrencyCode,
//         )}
//         /{row?.original?.quantityUnit}
//       </div>
//     ),
//     enableSorting: true,
//   },
//   { accessorKey: 'demandType', header: 'TYPE', enableSorting: true },
//   { accessorKey: 'activeBids', header: 'active bids', enableSorting: false },
//   // {
//   //   accessorKey: 'inactiveBids',
//   //   header: 'inactive bids',
//   //   enableSorting: false,
//   // },
//   {
//     accessorKey: 'createdAt',
//     header: 'Created At',
//     cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     enableSorting: true,
//   },
// ];

/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/react-in-jsx-scope */
import moment from 'moment';
import { RiUser3Line } from 'react-icons/ri';
import { VscChecklist } from 'react-icons/vsc';
import { GiDeliveryDrone } from 'react-icons/gi';
import UserInfo from 'components/UserInfo';
import { Badge, ListInlineItem } from 'reactstrap';
import DateFormatter from 'components/DateFormatter';
import { currencyToLocal, NumberWithCommasFormat } from 'utils/constants';

// Last 7 days
const last7DaysStart = moment().subtract(6, 'days').format('YYYY-MM-DD');
const last7DaysEnd = moment().add(1, 'day').format('YYYY-MM-DD');

// Last 30 days
const last30DaysStart = moment().subtract(29, 'days').format('YYYY-MM-DD');
const last30DaysEnd = moment().add(1, 'day').format('YYYY-MM-DD');

// Current year - yeh same rahega
const startDateOfYear = moment().startOf('year').format('YYYY-MM-DD');
const lastDateOfYear = moment().endOf('year').format('YYYY-MM-DD');

// Keep these for backward compatibility if needed elsewhere
export const startDateOfMonth = moment().startOf('month').format('YYYY-MM-DD');
export const lastDateOfMonth = moment().endOf('month').format('YYYY-MM-DD');

export const snapdata = [
  {
    title: 'Listing',
    subData: [
      { subTitle: 'New Demands', profit: false, count: '23k', total: 240 },
      { subTitle: 'New Offers', profit: true, count: 246, total: 240 },
    ],
    icon: VscChecklist,
    color: '#F6FBFF',
  },
  {
    title: 'User',
    subData: [
      { subTitle: 'KYC Pending', profit: true, count: '23k', total: null },
      { subTitle: 'New Offers', profit: true, count: 246, total: null },
    ],
    icon: RiUser3Line,
    color: '#F9F7FF',
  },
  {
    title: 'Orders',
    subData: [
      { subTitle: 'Delivered', profit: false, count: '23k', total: null },
      { subTitle: 'Active', profit: true, count: 246, total: null },
    ],
    icon: GiDeliveryDrone,
    color: '#FFF8F2',
  },
];

export const offerActiveBidColumns = [
  {
    accessorKey: 'bidder',
    header: 'SELLER',
    cell: ({ row }) => (
      <UserInfo
        name={`${row?.original?.bidder?.firstName} ${row?.original?.bidder?.lastName}`}
        mobileNumber={row?.original?.bidder?.phone}
      />
    ),
    sort: true,
  },
  {
    accessorKey: 'grade',
    header: 'GRADE',
    cell: ({ row }) => <div className="px-0">{row?.original?.grade?.name}</div>,
    sort: true,
  },
  {
    accessorKey: 'location',
    header: 'LOCATION',
    sort: true,
    cell: ({ row }) => (
      <>
        <div className="mb-1">
          {row?.original?.bidder?.addresses[0]?.city?.cityName}
        </div>
        <div className="font-manrope text-active">
          {row?.original?.bidder?.addresses[0]?.state?.stateName}{' '}
        </div>
      </>
    ),
  },

  {
    accessorKey: 'quantity',
    header: 'IN STOCK QTY',
    cell: ({ row }) => (
      <div className="px-0">
        {row.original.quantity + row.original.quantityUnit}
      </div>
    ),
    sort: true,
  },
  {
    accessorKey: 'price',
    header: 'RATE',
    cell: ({ row }) => (
      <div className="px-0">
        {row?.original?.rateUnit?.currencyName
          ? row?.original?.rateUnit?.currencyName
          : row?.original?.price
            ? row?.original?.price
            : ''}
      </div>
    ),
    sort: true,
  },
  { accessorKey: 'offer.offerType', header: 'TYPE', sort: true },
  {
    accessorKey: '',
    header: 'INACTIVE BID',
    cell: ({ row }) => (
      <div className="px-0">{row.original?.offer?.inactiveBids}</div>
    ),
    sort: true,
  },
  {
    accessorKey: '',
    header: 'ACTIVE BID',
    cell: ({ row }) => (
      <div className="px-0">{row.original?.offer?.activeBids}</div>
    ),
    sort: true,
  },
];

export const demandActiveBidColumns = [
  {
    accessorKey: 'bidder',
    header: 'BUYER',
    cell: ({ row }) => (
      <UserInfo
        name={`${row?.original?.bidder?.firstName} ${row?.original?.bidder?.lastName}`}
        mobileNumber={row?.original?.bidder?.phone}
      />
    ),
    sort: true,
  },
  {
    accessorKey: 'grade',
    header: 'GRADE',
    cell: ({ row }) => <div className="px-0">{row?.original?.grade?.name}</div>,
    sort: true,
  },
  {
    accessorKey: '',
    header: 'LOCATION',
    cell: ({ row }) => (
      <>
        <div className="mb-0">
          {row?.original?.bidder?.addresses[0]?.city?.cityName}
        </div>
        <div className="font-manrope text-active">
          {row?.original?.bidder?.addresses[0]?.state?.stateName}{' '}
        </div>
      </>
    ),
    sort: true,
  },

  {
    accessorKey: 'quantity',
    header: 'IN STOCK QTY',
    cell: ({ row }) => (
      <div className="px-0">
        {row.original.quantity + row.original.quantityUnit}
      </div>
    ),
    sort: true,
  },
  {
    accessorKey: 'price',
    header: 'RATE',
    cell: ({ row }) => (
      <div className="px-0">
        {row?.original?.rateUnit?.currencyName
          ? row?.original?.rateUnit?.currencyName
          : row?.original?.price
            ? row?.original?.price
            : ''}
        /kg
      </div>
    ),
    sort: true,
  },
  { accessorKey: 'demand.demandType', header: 'TYPE', sort: true },
  {
    accessorKey: '',
    header: 'INACTIVE BID',
    cell: ({ row }) => (
      <div className="px-0">{row.original?.demand?.inactiveBids}</div>
    ),
    sort: true,
  },

  {
    accessorKey: '',
    header: 'ACTIVE BID',
    cell: ({ row }) => (
      <div className="px-0">{row.original?.demand?.activeBids}</div>
    ),
    sort: true,
  },
];

export const options = {
  showTotal: true,
};

// formatXAxisLabels function - Updated
export const formatXAxisLabels = (selectedOption) => {
  if (selectedOption === 'this_year') {
    return [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
  } else if (selectedOption === 'last_30_days') {
    // Last 30 days ke liye dates generate करें
    const days = [];
    for (let i = 29; i >= 0; i -= 1) {
      const date = moment().subtract(i, 'days');
      days.push(date.format('D MMM'));
    }
    return days;
  } else if (selectedOption === 'last_7_days') {
    // Last 7 days ke liye dates generate करें
    const days = [];
    for (let i = 6; i >= 0; i -= 1) {
      const date = moment().subtract(i, 'days');
      days.push(date.format('D MMM'));
    }
    return days;
  }
  return [];
};

// defaultFiltersForDates function - Updated
export const defaultFiltersForDates = (groupOn) => {
  if (groupOn === 'this_year') {
    return {
      fromDate: startDateOfYear,
      toDate: lastDateOfYear,
      groupOn: 'month',
    };
  } else if (groupOn === 'last_30_days') {
    return {
      fromDate: last30DaysStart,
      toDate: last30DaysEnd,
      groupOn: 'day',
    };
  } else if (groupOn === 'last_7_days') {
    return {
      fromDate: last7DaysStart,
      toDate: last7DaysEnd,
      groupOn: 'day',
    };
  }
  return {
    fromDate: last7DaysStart,
    toDate: last7DaysEnd,
    groupOn: 'day',
  };
};

export const showDates = (dateString) => {
  const dateObject = moment(dateString, 'YYYY-MM-DD');
  return dateObject.format('D MMM');
};

export const CHART_BOTTOM_HEADING = [
  {
    id: 1,
    // title: 'New Listing',
    subTitle: [{ label: 'New Demands ' }, { label: 'New Offers' }],
  },
  {
    id: 2,
    title: 'Active Bids',
    subTitle: [{ label: 'New Demands ' }, { label: 'New Offers' }],
  },
  {
    id: 3,
    title: 'Vendors',
    subTitle: [{ label: 'New Vendors' }, { label: 'Total Vendors' }],
  },
  {
    id: 4,
    title: 'Orders',
    subTitle: [{ label: 'Pending Orders' }, { label: 'Paid Orders' }],
  },
];

export const getChartBottomHeading = (id) => {
  const title = CHART_BOTTOM_HEADING.find((val) => {
    if (val.id === id) return val;
  });
  return (
    <>
      <ListInlineItem>
        <span />
        {title?.subTitle[0]?.label}
      </ListInlineItem>
      <ListInlineItem>
        <span />
        {title?.subTitle[1]?.label}
      </ListInlineItem>
    </>
  );
};

export const COUNT_DATA = [
  {
    id: 1,
    title: 'Active Listing',
    subTitle: [
      { label: 'Offers', value: 23 },
      { label: 'Demands', value: 65 },
    ],
  },
  {
    id: 2,
    title: 'Active Bids',
    subTitle: [
      { label: 'Offers', value: 2386 },
      { label: 'Demands', value: 246 },
    ],
  },
  {
    id: 3,
    title: 'Vendors',
    subTitle: [
      { label: 'New', value: 2386 },
      { label: 'Total', value: 246 },
    ],
  },
  {
    id: 4,
    title: 'Orders',
    subTitle: [
      { label: 'Pending', value: 2386 },
      { label: 'Paid', value: 246 },
    ],
  },
];

export const DASHBOARD_TABS = {
  LISTINGS: 'Listings',
  BIDS: 'Bids',
  VENDORS: 'Vendors',
};

export const LISTING_TABS = {
  NEW_OFFERS: 'New Offers',
  NEW_DEMANDS: 'New Demands',
};

export const setChartValue = (val1, val2) => {
  const combinedKeysSet = new Set();
  let firstLineData = [];
  let secondLineData = [];
  if (val1) {
    firstLineData = Object.entries(val1).map(([key, value]) => {
      combinedKeysSet.add(key);
      return value;
    });
  }
  if (val2) {
    secondLineData = Object.entries(val2).map(([key, value]) => {
      combinedKeysSet.add(key);
      return value;
    });
  }
  const combinedKeys = Array.from(combinedKeysSet);
  return {
    firstLineData,
    secondLineData,
    combinedKeys,
  };
};

const getDisplayQuantityUnit = (row) =>
  row?.original?.actualQuantityUnit || row?.original?.quantityUnit || '';

export const dashboardOffersColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'trader',
    header: 'Seller',
    enableSorting: true,
    accessorFn: (row) => {
      return (
        <UserInfo
          name={row?.trader?.entityName}
          mobileNumber={`${row?.trader?.callingCode?.callingCode}-${row?.trader?.phone}`}
        />
      );
    },
    cell: (info) => info.getValue(),
  },
  { accessorKey: 'id', header: 'OFFER ID', enableSorting: true },
  {
    accessorKey: 'grades',
    header: 'GRADE',
    accessorFn: (row) => {
      return row?.grades?.map((grade) => {
        return (
          <Badge key={grade?.id} color="primary" className="me-1">
            {grade?.name}
          </Badge>
        );
      });
    },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  {
    accessorFn: (row) => {
      return (
        <>
          {row?.offerType === 'FOREIGN' ? (
            <div className="mb-1">
              {row?.portsOfDischarge?.map((portOfDischarge) => {
                return (
                  <div key={portOfDischarge?.id} className="me-1">
                    {`${portOfDischarge?.name},` || 'Not Available'}
                  </div>
                );
              })}
            </div>
          ) : (
            <>
              <div className="mb-1">
                {row.city?.cityName || 'Not Available'}
              </div>
              <div className="font-manrope text-active">
                {row.state?.stateName || 'Not Available'}
              </div>
            </>
          )}
        </>
      );
    },
    header: 'LOCATION',
    id: 'city.cityName',
    enableSorting: true,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: 'totalQty',
    header: 'Total Quantity',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.totalQty)}
        {getDisplayQuantityUnit(row)}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'minimumQty',
    header: 'min. QTY',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.minimumQty)}
        {getDisplayQuantityUnit(row)}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'rate',
    header: 'RATE',
    cell: ({ row }) => (
      <div>
        {currencyToLocal(
          row?.original?.rate,
          row?.original?.rateUnit?.isoCurrencyCode,
        )}
        /{row?.original?.quantityUnit}
      </div>
    ),
    enableSorting: true,
  },
  { accessorKey: 'offerType', header: 'TYPE', enableSorting: true },
  { accessorKey: 'activeBids', header: 'active bids', enableSorting: false },
  {
    accessorKey: 'createdAt',
    header: 'Created At',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
];

export const dashboardDemandsColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'trader',
    header: 'buyer',
    enableSorting: true,
    accessorFn: (row) => {
      return (
        <UserInfo
          name={row?.trader?.entityName}
          mobileNumber={`${row?.trader?.callingCode?.callingCode}-${row?.trader?.phone}`}
        />
      );
    },
    cell: (info) => info.getValue(),
  },
  { accessorKey: 'id', header: 'DEMAND ID', enableSorting: true },
  {
    accessorKey: 'grades',
    header: 'GRADE',
    accessorFn: (row) => {
      return row?.grades?.map((grade) => {
        return (
          <Badge key={grade?.id} color="primary" className="me-1">
            {grade?.name}
          </Badge>
        );
      });
    },
    cell: (info) => info.getValue(),
    enableSorting: false,
  },
  {
    accessorFn: (row) => {
      return (
        <>
          {row?.demandType === 'FOREIGN' ? (
            <div className="mb-1">
              {row?.portsOfDischarge?.map((portOfDischarge) => {
                return (
                  <div key={portOfDischarge?.id} className="me-1">
                    {`${portOfDischarge?.name},` || 'Not Available'}
                  </div>
                );
              })}
            </div>
          ) : (
            <>
              <div className="mb-1">
                {row.city?.cityName || 'Not Available'}
              </div>
              <div className="font-manrope text-active">
                {row.state?.stateName || 'Not Available'}
              </div>
            </>
          )}
        </>
      );
    },
    header: 'LOCATION',
    id: 'city.cityName',
    enableSorting: true,
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: 'totalQty',
    header: 'Total Quantity',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.totalQty)}
        {getDisplayQuantityUnit(row)}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'minimumQty',
    header: 'min. QTY',
    cell: ({ row }) => (
      <div>
        {NumberWithCommasFormat(row?.original?.minimumQty)}
        {getDisplayQuantityUnit(row)}
      </div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'rate',
    header: 'RATE',
    cell: ({ row }) => (
      <div>
        {currencyToLocal(
          row?.original?.rate,
          row?.original?.rateUnit?.isoCurrencyCode,
        )}
        /{row?.original?.quantityUnit}
      </div>
    ),
    enableSorting: true,
  },
  { accessorKey: 'demandType', header: 'TYPE', enableSorting: true },
  { accessorKey: 'activeBids', header: 'active bids', enableSorting: false },
  {
    accessorKey: 'createdAt',
    header: 'Created At',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
];
